import { useEffect, useState } from "react";
import DashboardLayout from "@/components/DashboardLayout";
import api from "@/lib/api";
import { Bell, CheckCircle } from "@phosphor-icons/react";

export default function Notifications() {
  const [items, setItems] = useState([]);
  const load = async () => { const { data } = await api.get("/notifications"); setItems(data); };
  useEffect(() => { load(); }, []);
  const markAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <DashboardLayout>
      <div className="flex items-center justify-between mb-5">
        <div>
          <div className="text-xs font-bold uppercase tracking-widest text-slate-500 dark:text-slate-400">Inbox</div>
          <h1 className="text-3xl font-black tracking-tighter text-slate-900 dark:text-white" style={{ fontFamily: "'Cabinet Grotesk', system-ui, sans-serif" }}>Notifications</h1>
        </div>
        <button data-testid="mark-all-btn" onClick={markAll} className="rounded-full bg-blue-700 hover:bg-blue-800 text-white font-bold px-4 py-2 text-sm inline-flex items-center gap-2 transition-colors duration-200"><CheckCircle size={16} weight="fill" /> Mark all read</button>
      </div>
      <div className="space-y-2">
        {items.length === 0 && <div className="rounded-2xl border-2 border-dashed border-slate-300 dark:border-slate-700 p-8 text-center text-slate-500">No notifications.</div>}
        {items.map((n) => (
          <div key={n.id} data-testid={`notif-${n.id}`} className={`rounded-2xl border p-4 ${n.read ? "border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900" : "border-blue-300 dark:border-blue-500/40 bg-blue-50 dark:bg-blue-950/30"}`}>
            <div className="flex items-start gap-3">
              <Bell size={20} weight={n.read ? "regular" : "fill"} className={n.read ? "text-slate-400" : "text-blue-600"} />
              <div className="flex-1">
                <div className="font-bold text-slate-900 dark:text-white">{n.title}</div>
                <div className="text-sm text-slate-600 dark:text-slate-300">{n.body}</div>
                <div className="text-xs text-slate-400 mt-1">{new Date(n.created_at).toLocaleString()}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </DashboardLayout>
  );
}
